import { Deserializable } from '../../deserializable';
import { FamilyDTO } from '../../responses/family/family';

/**
 * Model of second step of register form
 */
export class Equipment extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    public serial: string,
    public planModel?: string,
    public businessId?: number,
    public id?: number,
    public family?: FamilyDTO
  ) {
    super();
  }
}
